import { Injectable } from '@angular/core';
import { ProductModel } from '../../../models/master-data/products.model';
import { BaseService } from '../../../shared/services/base.service';
import { ProductCategoryUrl } from '../../../shared/urls/master-data.productcategory.url';
import { ProductUrl } from '../../../shared/urls/master-data.product.url';

@Injectable()
export class ProductsService {
    constructor(public baseService: BaseService) {

    }
    getProductCategoryList(){
        const url = ProductCategoryUrl.PRODUCTCATEGORY_GET_ALL;
        return this.baseService.getData(url);
    }

    getSuppliersList() {
        const url = ProductUrl.PRODUCT_GET_SUPPLIER;
        return this.baseService.getData(url);
    }

    // getProductList(param) {
    //     const url = ProductUrl.PRODUCT_GET;
    //     return this.baseService.getData(url, param);
    // }
    getProductByCategory(param) {
        const url = ProductUrl.PRODUCT_GET;
        return this.baseService.getData(url, param);
    }
    getProductById(id) {
        const url = ProductUrl.PRODUCT_DETAIL + `${id}`;
        return this.baseService.get(url)
    }
    updateProduct(id, param) {
        const url = ProductUrl.PRODUCT_UPDATE + `${id}`;
        return this.baseService.put(url, param);
    }
    removeProduct(id) {
        const url = ProductUrl.PRODUCT_DELETE.replace('{id}',id);
        return this.baseService.delete(url);
    }
    addNewProduct(param){
        const url = ProductUrl.PRODUCT_ADD;
        return this.baseService.postData(url, param);
    }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/products/products.service.ts